import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=ebc2ee5e&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebc2ee5e')) {
      api.createRecord('ebc2ee5e', component.options)
    } else {
      api.reload('ebc2ee5e', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=ebc2ee5e&", function () {
      api.rerender('ebc2ee5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wvzD47c4x4si/JS/comp/ImgFallback2.vue"
export default component.exports